import {useState} from 'react';
import {Provider} from '../lib/api';
export function TranslationBatchSize({provider,value,onChange}:{provider:Provider;value:string;onChange:(value:string)=>void}){
  const presets=['1','5','10','25','50','100'];
  const [custom,setCustom]=useState(value!==''&&!presets.includes(value));
  return <div className="translationBatchSize">
    <label>حداکثر سگمنت در هر درخواست — {provider.name}
      <select value={custom?'custom':value===''?'':presets.includes(value)?value:'custom'} onChange={e=>{setCustom(e.target.value==='custom');onChange(e.target.value==='custom'?(value||'5'):e.target.value)}}>
        <option value="">خودکار (پیش‌فرض مدل / سرور)</option>
        {[1,5,10,25,50,100].map(n=><option key={n} value={n}>{n} سگمنت</option>)}
        <option value="custom">عدد دلخواه</option>
      </select>
    </label>
    {(custom||value!=='')&&<label>عدد انتخابی (۱ تا ۱۰۰)<input type="number" min="1" max="100" step="1" required value={value} onChange={e=>onChange(e.target.value)} dir="ltr"/></label>}
    <small className="muted">این عدد سقف است؛ محدودیت طول متن و تلاش مجدد ممکن است بسته را کوچک‌تر کند. بسته‌های بزرگ‌تر ممکن است تطبیق متن و زمان را ضعیف کنند.</small>
  </div>
}
